import * as React from 'react'

const ScreenCenterLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        background: 'white'
      }}
    >
      {children}
    </div>
  )
}

export default ScreenCenterLayout
